import { convert } from "html-to-text";

export class StringUtils {
  static IsStringUndefinedNullOrEmpty(str: string | undefined | null): boolean {
    return str === undefined || str === null || str === "";
  }

  // Return the first `size` characters and append ellipsis when truncated.
  // Trim trailing whitespace first to avoid outputs like "text ...".
  static CapStringSize(str: string, size: number): string {
    if (str.length <= size) return str;
    return str.substring(0, size).trimEnd() + "...";
  }

  static GetHtmlFreePromptContent = (textContainsHtmlLineBreak: string): string => {
    if (StringUtils.IsStringUndefinedNullOrEmpty(textContainsHtmlLineBreak)) return "";

    const convStr = convert(textContainsHtmlLineBreak, {
      wordwrap: 1000,
      preserveNewlines: true,
    }); // Use a long wordwrap to avoid breaking the text
    return convStr;
  };
}
